import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Leaf = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M8.363 18.747s-3.838.003-6.726-.313a.401.401 0 0 1-.24-.682c3.664-3.664 7.417-7.162 11.14-10.766L.672 12.995A.454.454 0 0 1 0 12.587c.001-.478.009-1.252.032-2.493.403-6.64 11.773-8.306 16.595-8.715a1.83 1.83 0 0 1 1.987 2.003c-.923 10.331-5.076 15.658-10.25 15.365Z" }) }));
});
Leaf.displayName = 'Leaf';
export default Leaf;
//# sourceMappingURL=Leaf.js.map